import React from "react";
import Icon from "./Icon";

export const MoreIconVertical = () => (
  <Icon>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    />
  </Icon>
);
